/**
 * @file
 * CTA Block script.
 */

(function ctaBlockScript($, Drupal, once) {
  'use strict';

  function getCtaBlock(trigger) {
    const block = trigger.closest('.cta-block');
    return block || window.document;
  }

  function getTarget(trigger) {
    const targetID = trigger.getAttribute('data-cta-block-toggle-target') || '';
    if (!targetID) {
      return null;
    }

    const block = getCtaBlock(trigger);
    if (!block) {
      return null;
    }

    return block.querySelector(`[data-cta-block-toggle-target-id="${targetID}"]`);
  }

  function iframeOnLoadListener(event) {
    const iframe = event.currentTarget;
    iframe.classList.remove('cta-block__iframe-wrapper--loading');

    // Trigger a resize.
    // The iframe resize is setup in
    // ahs_formstack_api.embed.iframe.js for all embeds.
    if (('ahsIframeResizer' in Drupal) &&
        typeof Drupal.ahsIframeResizer !== 'undefined' &&
        ('resize' in Drupal.ahsIframeResizer)) {
      Drupal.ahsIframeResizer.resize(iframe);
    }
  }

  function loadIframe(iframe, $target) {
    const src = iframe.getAttribute('data-src');

    if (typeof src !== 'undefined' && src && src !== iframe.src) {
      const $iframeWrapper = $target.find('.cta-block__iframe-wrapper');
      if ($iframeWrapper.length > 0) {
        $iframeWrapper.addClass('cta-block__iframe-wrapper--loading');
      }

      // Listen for the iframe to be done loading.
      iframe.addEventListener('load', iframeOnLoadListener);

      // Update the src to load the iframe.
      iframe.src = src;
    }
  }

  function triggerClickKeydownListener(event) {
    if (event.type === 'keydown') {
      const key = event.key.toUpperCase();
      // Activated for Enter or Spacebar.
      const keyActivated = key === 'ENTER' || key === ' ' || key === 'SPACEBAR';
      if (!keyActivated) {
        return;
      }
    }

    event.preventDefault();

    const trigger = event.currentTarget;
    const $trigger = $(trigger);

    const target = getTarget(trigger);
    if (!target) {
      return;
    }
    const $target = $(target);

    let expandHelp = '';
    let collapseHelp = '';
    if (trigger.classList.contains('cta-block__toggle')) {
      expandHelp = trigger.getAttribute('data-expand-help') || '';
      collapseHelp = trigger.getAttribute('data-collapse-help') || '';
    }

    // Load iframes if the target is hidden.
    $(once('ctaBlockToggleLoadIframes', $target))
      .find('.cta-block__content')
      .find('iframe')
      .filter('[data-src]')
      .get()
      .forEach((iframe) => {
        loadIframe(iframe, $target);
      });

    $target.slideToggle({
      duration: 'fast',
      complete() {
        const $thisTarget = $(this);
        let $formInput;

        // Update aria attributes.
        if ($thisTarget.css('display') === 'none') {
          // Collapsed.
          $thisTarget.attr('aria-hidden', 'true');
          // Update the trigger.
          $trigger.attr('aria-expanded', 'false');
          if (expandHelp && $trigger.hasClass('cta-block__toggle')) {
            $trigger.attr('aria-label', expandHelp);
            Drupal.ahsThemeSite.scrollTop($trigger);
          }
        } else {
          // Expanded.
          $thisTarget.attr('aria-hidden', 'false');
          // Focus and scroll on the first input.
          // The embedded form is a Formstack form so target generic
          // input elements.
          $formInput = $thisTarget.find('input, select, textarea')
            .not(':button, :submit, :reset, :image, :file')
            .filter(':visible')
            .first();
          Drupal.ahsThemeSite.scrollTop($formInput);

          // Update the trigger.
          $trigger.attr('aria-expanded', 'true');
          if (collapseHelp && $trigger.hasClass('cta-block__toggle')) {
            $trigger.attr('aria-label', collapseHelp);
          }
        }
      },
    });
  }

  function initCtaBlock(trigger) {
    const $trigger = $(trigger);
    const target = getTarget(trigger);
    if (!target) {
      return;
    }

    let expandHelp = '';
    let collapseHelp = '';
    if (trigger.classList.contains('cta-block__toggle')) {
      expandHelp = trigger.getAttribute('data-expand-help') || '';
      collapseHelp = trigger.getAttribute('data-collapse-help') || '';
    }

    const $target = $(target);
    if ($target.length === 0) {
      return;
    }

    // Hide $target initially with JS so that it shows if JS is disabled.
    // Hide if no confirmation message.
    if ($target.find('.confirmation-message').length === 0) {
      $target.hide().attr('aria-hidden', 'true');
      $trigger.attr('aria-expanded', 'false');

      if (expandHelp && $trigger.hasClass('cta-block__toggle')) {
        $trigger.attr('aria-label', expandHelp);
      }
    } else if (collapseHelp && $trigger.hasClass('cta-block__toggle')) {
      $trigger.attr('aria-label', collapseHelp);
    }

    // Toggle $target visibility.
    $trigger.on('click keydown', triggerClickKeydownListener);
  }

  /**
   * CTA Block toggle.
   */
  Drupal.behaviors.themeCtaBlockToggle = {
    attach(context) {
      const triggers = once('themeCtaBlockToggle', '[data-cta-block-toggle-target]', context);
      if (!triggers.length) {
        return;
      }

      triggers.forEach((trigger) => {
        initCtaBlock(trigger);
      });
    },
  };
}(jQuery, Drupal, once));
